function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import * as React from "react";
import Cookies from "js-cookie";
/**
 * Cookie key for dark theme override, aligning to the one defined in
 * Admin.Controller.Dev.cs
 */ var ENABLE_SITE_DARK_THEME_COOKIE_KEY = "KG-ENABLE-SITE-DARK-THEME";
export var DarkModeContext = /*#__PURE__*/ React.createContext({
    darkModeEnabled: Boolean(Cookies.get(ENABLE_SITE_DARK_THEME_COOKIE_KEY))
});
export var DarkModeProvider = function(param) {
    var children = param.children;
    var ref = _slicedToArray(React.useState(Boolean(Cookies.get(ENABLE_SITE_DARK_THEME_COOKIE_KEY))), 2), darkModeEnabled = ref[0], setDarkModeEnabled = ref[1];
    React.useEffect(function() {
        if (darkModeEnabled) {
            Cookies.set(ENABLE_SITE_DARK_THEME_COOKIE_KEY, "true", {
                expires: Infinity
            });
        } else {
            Cookies.remove(ENABLE_SITE_DARK_THEME_COOKIE_KEY);
        }
    }, [
        darkModeEnabled
    ]);
    return /*#__PURE__*/ React.createElement(DarkModeContext.Provider, {
        value: {
            darkModeEnabled: darkModeEnabled,
            setDarkModeEnabled: setDarkModeEnabled
        }
    }, children);
};
